export async function renderSubsection2Block({
  data,
  content,
  renderBlocks,
  sectionNumber,
  level
}) {
  const isLandscape = !!data.landscapePage;

  // Kuvat ja Korjaussuositukset alkavat omalta sivulta
  const forceOwnPage =
    /^(kuvat|korjaussuositukset)$/i.test(
      (data.title || "").trim()
    );

  // Render child blocks first so we know whether
  // this subsection actually contains anything.
  const innerContent = [];

  if (Array.isArray(data.blocks)) {
    await renderBlocks(
      data.blocks,
      innerContent,
      sectionNumber,
      level + 1
    );
  }

  // Check whether rendered content is actually visible content
  const isRealContent = (item) => {
    if (!item) return false;

    if (typeof item.text === "string") {
      const text = item.text.trim();

      // Don't count empty/default recommendation messages
      if (
        text === "• Ei toimenpide-ehdotuksia." ||
        text === "Ei toimenpide-ehdotuksia."
      ) {
        return false;
      }

      return text.length > 0;
    }

    if (Array.isArray(item.text)) {
      return item.text.length > 0;
    }

    if (Array.isArray(item.stack)) {
      return item.stack.some(isRealContent);
    }

    if (Array.isArray(item.columns)) {
      return item.columns.some(isRealContent);
    }

    // Tables, images, canvas etc. count as real content
    if (item.table || item.image || item.svg || item.canvas) {
      return true;
    }

    return false;
  };

  const hasContent = innerContent.some(isRealContent);

  // Don't show an empty subsection header in the PDF
  if (!hasContent) {
    return;
  }

  const heading = {
    text: data.title || "Aliosio",
    style: "boldSubHeading",
    margin: [0, 8, 0, 10],

    ...(
      data.pageBreakBefore ||
      isLandscape ||
      forceOwnPage
        ? { pageBreak: "before" }
        : {}
    ),

    ...(isLandscape
      ? { pageOrientation: "landscape" }
      : {}),
  };

  const first = innerContent[0];
  const rest = innerContent.slice(1);

  // Keep heading + first table together
  if (first?.table) {
    const {
      unbreakable: _u,
      ...tableNode
    } = first;

    content.push({
      stack: [
        heading,
        tableNode
      ],
      unbreakable: true
    });

    content.push(...rest);
  } else {
    content.push({
      ...heading,
      keepWithNext: true
    });

    content.push(...innerContent);
  }

  // Return to portrait after landscape subsection
  if (isLandscape) {
    content.push({
      text: "",
      pageBreak: "before",
      pageOrientation: "portrait"
    });
  }
}